// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { XSwiper } from "@adl/App/Components/XngCarousel/XngCarousel.models";

/**
 * To calculate the number of slides can we show without any cut off.
 * @param swiper
 */
export const calculateNumOfSlides = (swiper: XSwiper) => {
    if (!swiper || !swiper.slides?.[0]?.children?.[0]) {
        return 1;
    }

    const containerWidth = swiper.size || 0;
    const slideItemSize =
        swiper.slides[0].children[0].getBoundingClientRect().width + (parseInt(`${swiper.passedParams?.spaceBetween}`, 10) || 0);
        
    return Math.floor(containerWidth / slideItemSize) || 1;
};

/**
 *
 * @param swiper
 * @param maximumNumOfSlidesPerView
 * @param numOfItems
 * @param onSlidesPerView
 */
export const updateSlidePerView = ({
    swiper,
    maximumNumOfSlidesPerView,
    onSlidesPerView,
}: {
    swiper: XSwiper;
    onSlidesPerView?: (slidesPerView?: number) => void;
    maximumNumOfSlidesPerView?: number;
}) => {
    // the feature doesn't support "vertical direction" yet
    if (!swiper.isHorizontal()) {
        return;
    }

    const numOfItems = calculateNumOfSlides(swiper);
    if (numOfItems !== swiper.params.slidesPerView) {
        const slidePerViewItems =
            maximumNumOfSlidesPerView && maximumNumOfSlidesPerView < numOfItems
                ? maximumNumOfSlidesPerView
                : numOfItems;
        swiper.params.slidesPerView = slidePerViewItems;
        onSlidesPerView && onSlidesPerView(slidePerViewItems);
        swiper.update();
    }
};

/**
 * To update slidesPerView value and show slides without cut off
 * @param swiper
 * @param maximumNumOfSlidesPerView
 * @param onSlidesPerView
 * @param enable
 */
export const xSlidesPerView = ({
    swiper,
    maximumNumOfSlidesPerView,
    onSlidesPerView,
    enable,
}: {
    swiper?: XSwiper;
    maximumNumOfSlidesPerView?: number;
    onSlidesPerView?: (slidesPerView?: number) => void;
    enable?: boolean;
}) => {
    if (!swiper || !enable) {
        return;
    }

    /**
     * Initialize:
     * 1. add position:relative to the div before xngCarousel
     * 2. set number of slides
     * 3. add swiperResize listener to detect when window size change
     */
    updateSlidePerView({ swiper, maximumNumOfSlidesPerView, onSlidesPerView });

    // Resize listener
    swiper.on("resize", swiper => {
        updateSlidePerView({ swiper, maximumNumOfSlidesPerView, onSlidesPerView });
    });
};
